import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';

import type {SupportedAssets} from '@/types';
import {formatValues} from '@/utils/dashboard';

import type {UserDetailsReturnProps} from './types';

type UserWalletBalanceProps = Pick<
  UserDetailsReturnProps,
  'walletBalances' | 'isLoadingWalletBalances'
>;

const UserWalletBalance = ({
  walletBalances,
  isLoadingWalletBalances,
}: UserWalletBalanceProps): ReactElement => {
  const loadedContent = !isEmpty(walletBalances) ? (
    <ul>
      {Object.keys(walletBalances)?.map((key: string) => {
        return (
          <li key={key}>
            {key}
            {' -> '}
            {formatValues(walletBalances?.[key as SupportedAssets], 'money')}
          </li>
        );
      })}
    </ul>
  ) : (
    '0'
  );

  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-200">
        Wallet Balance
      </h3>

      <div>
        {isLoadingWalletBalances ? (
          <p className="text-sm">Loading...</p>
        ) : (
          loadedContent
        )}
      </div>
    </div>
  );
};

export default UserWalletBalance;
